import backend from '@/services/backend'

export default {

    getInterviewDetails (authToken, realmName, studyName, path, externId) {
        //return backend.get('interview/details/' + realmName + "/" + studyName + "/" + path, { headers: { Authorization: authToken }} )
        return backend({ method: 'post', url: 'interview/details/'+realmName+'/'+studyName, data: { externId: externId, path: path  }, headers: { Authorization: authToken } })
    }

}

